module.exports = __webpack_public_path__ + "img/playstore.835c2001.svg";